module.exports = __webpack_public_path__ + "static/media/TeamWork3Blackdot01.53502777.png";